import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { utilityManagementUrl } from '../../../../../../constants';

export interface Attachment {
  id: string;
  name: string;
  size: number;
  downloadUrl: string | undefined | null;
  type?: string;
  objectURL?: string;
}
@Injectable({
  providedIn: 'root',
})
export class AttachmentModalService {
  constructor(private http: HttpClient) { }

  getDownloadURL(id: string | undefined): Observable<Attachment> {
    return this.http.get<Attachment>(
      `${utilityManagementUrl}/attachments/${id}/as-download-url`
    );
  }
}
